// extracted by mini-css-extract-plugin
export default {"table_content":"CalendarDays_table_content__-94zr","day_number":"CalendarDays_day_number__mxRUn","event":"CalendarDays_event__IYJ+9","event_name":"CalendarDays_event_name__mYc+m"};